import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { PhoneIcon, EmailIcon, InfoIcon, DeleteIcon } from "@chakra-ui/icons";
import {
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverHeader,
	PopoverBody,
	PopoverFooter,
	PopoverArrow,
	PopoverCloseButton,
	Button,
	Stack,
	Text,
	Box,
	useToast,
	Divider,
	HStack,
	VStack,
} from "@chakra-ui/react";
import { CgProfile } from "react-icons/cg";

import { removeContactAsync } from "../../redux/user/userSlice";
import { contactTypes } from "../../utils/types";

export default function ContactPopover({ contact, property }) {
	const dispatch = useDispatch();
	const toast = useToast();
	const contactType = contactTypes.find((type) => type.id === contact.contactType)?.label || "-";
	console.log("contact", contact);
	const { t } = useTranslation();
	const handleContactDelete = (contact) => {
		const payload = { ...contact, propertyId: property.id };
		dispatch(removeContactAsync(payload)).then((r) => {
			if (r.error?.message)
				toast({
					title: "Error encountered",
					description: r.error.message,
					status: "error",
					duration: 9000,
					isClosable: true,
				});
			else {
				toast({
					title: "Success!",
					description: "Contact Removed!",
					status: "success",
					duration: 2000,
					isClosable: true,
				});
			}
		});
	};

	return (
		<Popover>
			<PopoverTrigger>
				<Button
					width={"fit-content"}
					maxW="200px"
					size={"sm"}
					variant="outline"
					_hover={{ bg: "gray.100" }}
					fontWeight="medium"
					textTransform={"capitalize"}
					leftIcon={<InfoIcon />}
				>
					<Text isTruncated>{contact.name}</Text>
				</Button>
			</PopoverTrigger>
			<PopoverContent>
				<PopoverArrow />
				<PopoverCloseButton />
				<PopoverHeader borderBottomWidth="1px" p={4} bg="gray.50" borderTopRadius="md">
					<VStack align="flex-start">
						<Text fontWeight="semibold">{t("property.contactInformation")}</Text>
						<Text as="span" color="gray.500" fontSize="sm">
							{contactType}
						</Text>
					</VStack>
				</PopoverHeader>
				<PopoverBody py={4}>
					<Stack spacing={4} style={{ whiteSpace: "normal" }}>
						<Box>
							<HStack spacing={2} align="center">
								<CgProfile color="gray.600" />
								<Text flex="1" fontWeight="medium">
									{contact.name}
								</Text>
							</HStack>
						</Box>
						<HStack spacing={2} align="center">
							<EmailIcon color="blue.500" />
							<Text flex="1" fontWeight="medium">
								{contact.email}
							</Text>
						</HStack>
						<HStack spacing={2} align="center">
							<PhoneIcon color="green.500" />
							<Text flex="1" fontWeight="medium">
								{contact.phoneNumber}
							</Text>
						</HStack>
						{contact.phoneNumber2 && (
							<HStack spacing={2} align="center">
								<PhoneIcon color="green.500" />
								<Text flex="1" fontWeight="medium">
									{contact.phoneNumber2}
								</Text>
							</HStack>
						)}
					</Stack>
				</PopoverBody>
				<Divider />
				<PopoverFooter p={4} display="flex" justifyContent="flex-end">
					<Button size="sm" colorScheme="red" variant="ghost" leftIcon={<DeleteIcon />} onClick={() => handleContactDelete(contact)} _hover={{ bg: "red.50" }}>
						Delete Contact
					</Button>
				</PopoverFooter>
			</PopoverContent>
		</Popover>
	);
}
